<app-page-wrapper [title]="'Klienci'" [loading]="false" [error]="null">
  @if (isOwner()) {
    <p-card class="clients-page__quick-add-card mb-5">
      <div class="clients-page__quick-add">
        <div class="clients-page__quick-add-copy">
          <p class="clients-page__eyebrow">Szybkie dodawanie</p>
          <h3 class="clients-page__title">Dodaj nowego klienta</h3>
          <p class="clients-page__subtitle">
            Wpisz samą nazwę, a resztę danych możesz uzupełnić później w edycji.
          </p>
        </div>

        <form [formGroup]="newClientFormGroup" class="clients-page__quick-add-form">
          <div class="clients-page__quick-add-field">
            <p-floatlabel variant="on">
              <input
                pInputText
                id="addNewClientNameInput"
                formControlName="name"
                autocomplete="off"
                class="w-full"
              />
              <label for="addNewClientNameInput">Nazwa nowego klienta</label>
            </p-floatlabel>

            <div class="min-h-[1.25rem] ps-1 text-red-600">
              <ng-container *ngIf="name?.invalid && name?.touched">
                <div *ngIf="name?.hasError('clientExists')">
                  <small>Klient o takiej nazwie już istnieje.</small>
                </div>
              </ng-container>
            </div>
          </div>

          <p-button
            class="clients-page__quick-add-button"
            label="Dodaj klienta"
            (click)="onAddClient()"
            [disabled]="newClientFormGroup.invalid"
          ></p-button>
        </form>
      </div>
    </p-card>
  }

  <p-card class="clients-page__list-card">
    <div class="clients-page__list-toolbar">
      <div>
        <p class="clients-page__eyebrow">Filtr</p>
        <h3 class="clients-page__title">Szukaj po nazwie</h3>
        <p class="clients-page__subtitle">
          Użyj pola wyszukiwania, żeby szybko zawęzić widok tabeli klientów.
        </p>
      </div>

      <p-floatlabel variant="on" class="clients-page__search">
        <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input
            (input)="onClientSearch($event)"
            pInputText
            [disabled]="false"
            id="searchClientByNameInput"
            autocomplete="off"
          />
        </p-iconfield>
        <label for="searchClientByNameInput">Szukaj po nazwie</label>
      </p-floatlabel>
    </div>

    <app-client-list
      [isOwner]="isOwner()"
      [rows]="rows()"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [clients]="clients()"
      [currentPage]="currentPage()"
      [onLazyLoad]="lazyLoadClients"
      [onEditRequest]="onEditClient"
      [onDeleteRequest]="onDeleteClient"
    ></app-client-list>
  </p-card>
</app-page-wrapper>
